import React, { useEffect, useRef, useState } from "react";
import "./Projects.css";
import Bakery from "./images/bakery.png";
import Edolindi from "./images/Edolindi.png";
import RealEstate from "./images/RealEstate.png";
import Kosovo from "./images/Kosovo.png";


function Projects({ introDone }) {
  const containerRef = useRef(null);
  const headerRef = useRef(null);
  const [cardsVisible, setCardsVisible] = useState(false);
  const [headerVisible, setHeaderVisible] = useState(false);
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (!introDone) return;

    const headerObserver = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setHeaderVisible(true); },
      { threshold: 0.3 }
    );

    const cardObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasTriggered.current) {
          hasTriggered.current = true;
          setCardsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (headerRef.current) headerObserver.observe(headerRef.current);
    if (containerRef.current) cardObserver.observe(containerRef.current);

    return () => {
      headerObserver.disconnect();
      cardObserver.disconnect();
    };
  }, [introDone]);

  const projects = [
    {      Image: Kosovo,
      title: "Kosovo Guide",
      description: "A Kosovo travel guide with a React Native app and Laravel web app backed by Supabase, plus a React.js main website.",
      link: "https://kosovoguide.info/",
      technologies: ["React Native", "Supabase", "React.js", "Laravel"]
    },
    {
      Image: Bakery,
      title: "Bakery Website",
      description: "A responsive website for a local bakery, showcasing their products and allowing customers to place orders online.",
      link: "https://bakery04.netlify.app/",
      technologies: ["React.js", "ChatBase AI Agent"],
      featured: "1st place in Prizren Code Fest 2025"
    },
    {
      Image: Edolindi,
      title: "Edolindi Website",
      description: "A responsive website for AgroPharmacy, showcasing their products and services.",
      link: "https://edolindi.com/",
      technologies: ["HTML", "CSS", "JavaScript", "Bootstrap"],
    },
    {      Image: RealEstate,
      title: "Real Estate Website",
      description: "A comprehensive real estate listing platform with property search, and agent connectivity.",
      link: "https://example.com/project3",
      technologies: ["php", "MySQL", "Bootstrap"]
    }
    
  ];

  return (
    <div>
      <div
        ref={headerRef}
        className={`projects-header ${headerVisible ? "header-visible" : ""}`}
      >
        <h2 className="Projects">Projects</h2>
        <p className="projects-subtitle">Things I've built so far</p>
      </div>

      <div className="projects-container" ref={containerRef}>
        {projects.map((project, index) => (
          <div
            className={`project-card ${cardsVisible ? "card-visible" : ""}`}
            style={{ "--card-i": index }}
            key={index}
          >
            <div className="card-image-wrapper">
              <img src={project.Image} alt={project.title} className="project-image" />
              {project.featured && (
                <div className="featured-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fbbf24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="featured-icon">
                    <path d="M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15"/>
                    <path d="M11 12 5.12 2.2"/>
                    <path d="m13 12 5.88-9.8"/>
                    <path d="M8 7h8"/>
                    <circle cx="12" cy="17" r="5"/>
                    <path d="M12 18v-2h-.5"/>
                  </svg>
                  <div className="featured-tooltip">{project.featured}</div>
                </div>
              )}
            </div>
            <h2>{project.title}</h2>
            <p>{project.description}</p>
            <div className="technologies">
              {project.technologies.map((tech, techIndex) => (
                <span key={techIndex} className="tech-tag">{tech}</span>
              ))}
            </div>
            <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">View Project</a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;